import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip,
  MenuItem,
  Menu,
  Stack, Button,
  InputBase
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown, Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import CatPagination from '../reusable/catPagination/CatPagination';
import { useNavigate } from 'react-router-dom';
import Operations from '../reusable/Operations';

import { fomateDate } from '../../utils/fomateDate';

import '../reusable/calendar/calendar.css'
import { deleteSampleRequestThunk, setSampleSearch } from '../../redux/sampleRequestSlice';

// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderBottom: '1px solid #E6E1E5',
  padding: '4px 40px',
  fontSize: '14px',
  color: '#667085',
}));

const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));
const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));



const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));





const AllSampleReqTable = ({ sampleRequestData, page, setPage, itemsPerPage, start, end, totalItems,handleOpenMenu }) => {


  const [selectedId, setSelectedId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch()
  const navigate = useNavigate()

  //delete
  const deleteCategory = () => {
    dispatch(deleteSampleRequestThunk(selectedId))
    setIsModalOpen(false);
  }

  //delete modal open
  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };
 

  return (
    <>
      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell>
                 ID
                <IconButton onClick={(e) => handleOpenMenu('_id')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Customer
                <IconButton onClick={(e) => handleOpenMenu('name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Products
                <IconButton onClick={(e) => handleOpenMenu('product')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Date
                <IconButton onClick={(e) => handleOpenMenu('date')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
              Quantity
                <IconButton onClick={(e) => handleOpenMenu('quantity')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {sampleRequestData?.map((row) => (
              <TableRow key={row.id}>

                <ProductText sx={{ width: '13%' }}>{row?._id}</ProductText>

              

                {/* <ProductText sx={{ width: '12%' }}>{row?.endUser}</ProductText> */}

                <TableCells sx={{
                  width: '10%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.user?.fullName}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row?.user?.email}
                      </div>
                    </div>
                  </div>
                </TableCells>
                <TableCells sx={{
                  width: '10%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row?.product?.productOverview?.productNumber[0]}</strong>
                      <div style={{ fontSize: '12px', color: '#667085', fontWeight: '500', }}>
                        {row?.product?.productOverview?.manufacturer[0]?.name}
                      </div>
                    </div>
                  </div>
                </TableCells>


                <TableCells sx={{ width: '12%', fontSize: '12px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row?.createdAt)}
                </TableCells>
                <ProductText sx={{ width: '12%' }}>{row?.quantity}</ProductText>

            


                <TableCells sx={{ width: '11%' }}>
                  {row?.status === "NEW" ? (
                    <New label="New" size="small" />
                  ) :  (
                    <Delivered label="Completed" size="small" />
                  )}
                </TableCells>


                <Operations sx={{ width: '8% !important' }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`/sample/sampleRequestsDetails/${row?._id}`)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  selectedTab={1}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Sample Request'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deleteCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllSampleReqTable;
